export const ESIGN_SIGN_TYPE_OPTIONS = [
  { value: "DIGITAL_ESIGN_EMAIL", label: "Digital eSign (Email)" },
  { value: "DIGITAL_ESIGN_WHATSAPP", label: "Digital eSign (WhatsApp)" },
  { value: "AADHAAR_ESIGN_OTP", label: "Aadhaar eSign (OTP)" },
] as const;

export type SignTypeValue = (typeof ESIGN_SIGN_TYPE_OPTIONS)[number]["value"];

export const SIGN_TYPE = {
  EMAIL: "DIGITAL_ESIGN_EMAIL",
  WHATSAPP: "DIGITAL_ESIGN_WHATSAPP",
  AADHAAR_OTP: "AADHAAR_ESIGN_OTP",
} as const;
